import React, { useState } from "react";
import { Button, Steps, theme } from "antd";
import PlaceMap from "../components/Place/PlaceMap";
import PlaceDetailForm from "../components/Place/PlaceDetailForm";
import { useContext } from "react";
import { context } from "../context/context";

import { http } from "../services/httpService";
import config from "../services/config.json";
import AddMedia from "../components/Place/AddMedia";
import { useNavigate } from "react-router";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";

const steps = [
    {
        title: "انتخاب مکان",
        content: <PlaceMap />,
    },
    {
        title: "جزئیات مکان",
        content: <PlaceDetailForm />,
    },
    {
        title: "انتخاب عکس",
        content: <AddMedia />,
    },
];
const AddPlace = () => {
    const { token } = theme.useToken();
    const [current, setCurrent] = useState(0);
    const {
        addNamePlace,
        isCategorySelected,
        isCountrySelected,
        isProvinceSelected,
        addAddressPlace,
        latLng,
        setAddAddressPlace,
        placesId,
        setPlacesId,
        placeFormTag,
        addPhonePlace,
        selectedProvince,
        selectedCountry,
        selectedCityId,
        selectedCategoryId,
        textEditorHTML,
        linkTags,
        selectedSubCategoryId,
        fileListIds,
        coverPicId,
        setLatLng,
        setFileList,
        setCoverPic,
        coverPic,
        setFileListIds,
    } = useContext(context);
    const next = () => {
        if (current === 0) {
            http.post(`${config.parkopoloApi}/api/Place/addMap`, {
                lat: `${latLng[0]}`,
                lng: `${latLng[1]}`,
            })
                .then((res) => {
                    setAddAddressPlace(res.data.result.address);
                    setPlacesId(res.data.result._id);
                })
                .catch((err) => {
                    console.log(err);
                });
        } else if (current === 1) {
            http.post(`${config.parkopoloApi}/api/Place/addPlace`, {
                placeId: placesId,
                title: addNamePlace,
                tags: placeFormTag,
                province: selectedProvince._id,
                country: selectedCountry._id,
                city: selectedCityId,
                village: selectedCityId,
                category: selectedCategoryId,
                subCategory: selectedSubCategoryId,
                data: textEditorHTML,
                links: linkTags,
                phone: addPhonePlace,
                address: addAddressPlace,
            })
                .then((res) => {
                    console.log(res);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
        setCurrent(current + 1);
    };
    const navigate = useNavigate();
    const handleSendMedia = () => {
        http.post(`${config.parkopoloApi}/api/Place/addMedia`, {
            placeId: placesId,
            coverPic: coverPicId,
            media: fileListIds,
        })
            .then((res) => {
                toast.success("مکان با موفقیت ساخته شد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
            })
            .catch((err) => {
                toast.error("خطایی رخ داد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(err);
            });
        setLatLng();
        setFileList([]);
        setFileListIds([]);
        setCoverPic([]);
        navigate("/place", { replace: true });
    };
    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));
    const contentStyle = {
        lineHeight: "260px",
        textAlign: "center",
        color: token.colorTextTertiary,
        backgroundColor: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        border: `1px dashed ${token.colorBorder}`,
        marginTop: 16,
    };
    return (
        <div style={{ direction: "ltr" }}>
            <Steps current={current} items={items} />
            <div style={contentStyle}>{steps[current].content}</div>
            <div
                style={{
                    marginTop: 24,
                    textAlign: "left",
                    gap: "10px",
                    display: "flex",
                }}
            >
                {current < steps.length - 1 && (
                    <Button
                        type="primary"
                        onClick={() => next()}
                        disabled={
                            (current === 1 &&
                                (!addNamePlace ||
                                    addNamePlace === "" ||
                                    !isCategorySelected ||
                                    !isCountrySelected ||
                                    !isProvinceSelected ||
                                    !addPhonePlace ||
                                    addPhonePlace === "" ||
                                    !selectedCityId)) ||
                            (current === 0 && !latLng)
                        }
                    >
                        مرحله بعد
                    </Button>
                )}
                {current === steps.length - 1 && (
                    <Button
                        disabled={!coverPicId}
                        type="primary"
                        onClick={() => handleSendMedia()}
                    >
                        ثبت
                    </Button>
                )}
                {
                    <NavLink to="/place">
                        <Button type="primary" danger>
                            لغو
                        </Button>
                    </NavLink>
                }
                {/* {current > 0 && (
                    <Button
                        style={{
                            margin: "0 8px",
                        }}
                        onClick={() => prev()}
                    >
                        مرحله قبل
                    </Button>
                )} */}
            </div>
        </div>
    );
};
export default AddPlace;
